export default __webpack_public_path__ + "static/media/speckle.01887b0b.png";